<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-1"></div>
    <div class="col-sm-4 px-0 d-sm-block">
      <div class="image404-container">
        <img src="assets/images/404.png" class="img-fluid" alt="Responsive image">
      </div>
    </div>
    <div class="col-sm-1"></div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <form>
            <span class="error-header p-b-45">
              Oops....
            </span>
            <span class="error-subheader p-b-5">
              Looks Like You're Lost
            </span>
            <span class="error-subheader2 p-b-5">
              The Page You Are Looking For Not Available!
            </span>
            <div class="container-auth-form-btn mt-5">
              <a routerLink="/" class="auth-form-btn">
                Go To Home Page
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>